































































































































































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */

import { LineItem } from "@/models/order/order";
import { FinishDisplayName, FinishHandle } from "@/models/products/finish";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Swatch from "../products/Swatch.vue";
import { getFinishName } from "@/utility/helpers";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { GlobalGetters } from "@/store/modules/global/types";

@Component
export default class CartModal extends Vue {
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMultiplier))
  multiplier!: number;
  @Prop() cartInfo!: {
    qty?: number;
    model: string;
    productline?: string;
    name?: string;
    finish?: FinishHandle;
    fabric?: Swatch[];
    options?: object;
    cost?: number;
    quickshipList?: LineItem[];
    accessoryList?: LineItem[];
    sku: string;
  };

  @Watch("finish")
  private getFinishName(stringHandle: FinishHandle): FinishDisplayName {
    return getFinishName(stringHandle);
  }
}
